import React from 'react';
import Participant from '../../Participant/videoRoom/Participant';
import { styled } from '@material-ui/core/styles';
import { useState, useEffect } from 'react';

import { Popover } from "antd";
import useParticipants from '../../../hooks/useParticipants/useParticipants';
import useParticipantsList from '../../../hooks/useParticipants/useParticipantsList';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import useSelectedParticipant from '../../VideoProvider/useSelectedParticipant/useSelectedParticipant';
import { isMobile } from 'react-device-detect';
import ParticipantConnectionIndicator from '../../ParticipantInfo/ParticipantConnectionIndicator/ParticipantConnectionIndicator';
import ParticipantStripItem from '../../ParticipantStripItem/ParticipantStripItem';
import useParticipantsAudioToggle from '../../../hooks/useParticpantsAudioToggle/useParticipantsAudioToggle';
import useLocalAudioToggle from '../../../hooks/useLocalAudioToggle/useLocalAudioToggle';

const Container = styled('aside')(({ theme }) => ({
  padding: '0.5em'
}));

  const allMenu = (handleClick: any) =>{ 
    return(
    <div className="account-settings">
          <ul>
          <li onClick={() => handleClick()}>
             <a><img src="/images/unmute-icon.png" />&nbsp;Mute All</a>
          </li>
           </ul>
       </div>
    )};

export default function ParticipantStrip(props: any) {
  const { activeCalls, muteUnmuteAllParticipants, muteUnmuteParticipant, showMute, currentUser, guestMobileNumber, params } = props;
  const {
    room: { localParticipant },
  } = useVideoContext();
  const participants = useParticipants();
  const participantList = useParticipantsList(participants, params);
  const [selectedParticipant, setSelectedParticipant] = useSelectedParticipant();
  const [isParticipantsAudioEnabled, toggleParticipantsAudio] = useParticipantsAudioToggle();
  const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();

  const unMutedCall = activeCalls.find((call: any) => call.isMute !== "true");
  let [showMuteOption, setShowMuteOption] =  useState('hide');
  let [status, setShowMuteStatus] =  useState(true);

  let toggleShowHide = () => {

    if(showMuteOption == 'hide'){
      setShowMuteOption('show')
    } else {
      setShowMuteOption('hide')
    }

  }
  let muteUnmuteStatus = (status: any) => {
    if(status == true){
      setShowMuteStatus(false)
    } else {
      setShowMuteStatus(true)
    }

  }

  
  let muteUnmuteSelf = () => {

    toggleParticipantsAudio(props, muteUnmuteStatus, participants)
  }
  return (
    <Container  className={"particicant-strip particicant-strip-container participant-thumb-container"} id={!isMobile ? "strip-contatiner" : ""}>
      <div>
      <div className="blue-header"><h1>{participants.length + 1} participants
        
      </h1>
        {muteUnmuteAllParticipants && 
          <div className="menu-cont">
            <Popover id="userdropdownMenu" placement="bottomRight" >
              <div className="thumb-menu" onClick={() => toggleShowHide()}>
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
              </div>

            </Popover>
            {showMuteOption == "show" && <div id="userdropdownMenuItem" >
              <div className="account-settings">
                <ul>
                  <li onClick={() => toggleParticipantsAudio(props, muteUnmuteStatus, participants)}>
                    <a><img src="/images/unmute-icon.png" />&nbsp;
                      {status == true ? <span>Mute All</span> : <span>Unmute All</span>}

                    </a>
                  </li>
                </ul>
              </div>
            </div>}
          </div>
        }
       
      </div>
      <header className="headermenu">
      <ParticipantConnectionIndicator participant={localParticipant} />
        <h3>You 
          </h3>
      
      </header>
      <div className="participant-single room-thumbnail organizer">
      <Participant
        guestMobileNumber={guestMobileNumber}
        muteUnmuteSelf={() => toggleAudioEnabled(props)}
        muteUnmuteParticipant={muteUnmuteParticipant}
        muteUnmuteAllParticipants={muteUnmuteAllParticipants}
        currentUser={currentUser}
        activeCalls={activeCalls}
        participant={localParticipant}
        localParticipantFlag={true}
        self={true}
        isSelected={selectedParticipant === localParticipant}
        onClick={() => setSelectedParticipant(localParticipant)}
      />
      </div>
      </div>
      {participants.map((participant, index) =>
        <ParticipantStripItem
          currentUser={currentUser}
          participantList={participantList}
          muteUnmuteAllParticipants={muteUnmuteAllParticipants}
          guestMobileNumber={guestMobileNumber}
          participant={participant}
          activeCalls={activeCalls}
          participants={participants}
          index={index}
          selectedParticipant={selectedParticipant}
          showMute={showMute}
          muteUnmuteParticipant={muteUnmuteParticipant}
          setSelectedParticipant={setSelectedParticipant}
        />)}
    </Container>
  );
}

// {participants.map((participant, index) => 
//   <ParticipantStripItem 
//     participant={participant} 
//     activeCalls={activeCalls} 
//     index={index}
//     selectedParticipant={selectedParticipant}
//     showMute={showMute}
//     muteUnmuteParticipant={muteUnmuteParticipant}
//     setSelectedParticipant={setSelectedParticipant}
//   />)}


// {participants.map((participant, index) => {
//   let participantName = participant.identity;
//   if (participantName) {
//     participantName = participantName.split("_")[0];
//     if (participantName.toLowerCase().includes("screenshare")) participantName = participantName.replace('screenshare', '');
//   }
//   let callParticipant = activeCalls.find((activeCall: any) => {
//     if (participant.identity.indexOf(activeCall.mobileNumber) !== -1) {
//       return true;
//     }
//     let patientName = activeCall.patient.split(" ")[0] + (activeCall.patient.split(" ")[1] ? activeCall.patient.split(" ")[1] : "");
//     if (participant.identity.indexOf(patientName) !== -1) {
//       return true;
//     }
//     return false;
//   })
//   return (<div>
//     <header className="headermenu">
//       <ParticipantConnectionIndicator participant={participant} />
//       <h3>{participantName}</h3>
//       {false && (showMute && (callParticipant && callParticipant.isMute !== "true")) && <div className="menu-cont">
//         <Popover id="userdropdownMenu" placement="bottomRight" content={usrMenu(callParticipant ? () => muteUnmuteParticipant(callParticipant.callId) : undefined)} trigger="click">
//           <div className="thumb-menu">
//             <div className="circle"></div>
//             <div className="circle"></div>
//             <div className="circle"></div>
//           </div>
//         </Popover>
//       </div>}
//     </header>
//     <div className="participant-single room-thumbnail participant" key={index}>
//       <Participant
//         key={participant.sid}
//         participant={participant}
//         localParticipantFlag={false}
//         isSelected={selectedParticipant === participant}
//         onClick={() => {
//           setSelectedParticipant(participant)
//         }}
//       />
//     </div>
//   </div>)
// }

// )}
